export default __webpack_public_path__ + "static/media/back.159fe5c9.svg";